import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
// import history from '@source/history';
import Link from '@components/Link';
// import moment from 'moment';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// import PropTypes from 'prop-types';

import s from './NotificationMobile.css';
import matchesActions from '@actions/matches';
import { setLiveNotificationVariable } from '@actions/live-notification';
import iconLive from '../assets/images/iconLive.svg';
// import iconArrowRight from './assets/images/IconArrowRight.svg';

// var matchesList = [];
let isNotifClosed = true;
class NotificationMobile extends Component {
  state = {
    closeNotification: false,
    matchesList: []
  };
  // static propTypes = {
  //   page: PropTypes.string.isRequired
  // };
  async componentDidMount() {
    const { onHandleVideo } = this.props;
    const { videos } = this.props.matches;
    if (videos.meta.status !== 'success') {
      onHandleVideo();
    } else {
      const matchesSortedDate = videos.data.sort(
        (a, b) => a.startTime - b.startTime
      );
      const todayMatch = matchesSortedDate.filter(match => {
        return (
          Date.now() > match.startTime * 1000 &&
          Date.now() < match.endTime * 1000
        );
      });
      // matchesList = todayMatch;
      const { setNotifStatus } = this.props;
      const isOpenVar = todayMatch.length > 0;
      setNotifStatus(isOpenVar);
      this.setState({
        closeNotification: todayMatch.length === 0,
        matchesList: todayMatch
      });
    }
    isNotifClosed = sessionStorage.getItem('isNotifClosed')
      ? sessionStorage.getItem('isNotifClosed')
      : false;
  }

  componentDidUpdate(prevProps) {
    const { videos } = this.props.matches;
    if (
      prevProps.matches.videos.meta.status !== videos.meta.status &&
      videos.meta.status == 'success' &&
      this.state.matchesList.length === 0
    ) {
      const matchesSortedDate = videos.data.sort(
        (a, b) => a.startTime - b.startTime
      );
      const todayMatch = matchesSortedDate.filter(match => {
        return (
          Date.now() > match.startTime * 1000 &&
          Date.now() < match.endTime * 1000
        );
      });
      // matchesList = todayMatch;
      const { setNotifStatus } = this.props;
      const isOpenVar = todayMatch.length > 0;
      setNotifStatus(isOpenVar);
      this.setState({
        closeNotification: todayMatch.length === 0,
        matchesList: todayMatch
      });
    }
  }
  // handleClickLiveWatch = () => {
  //   const { matchesList } = this.state;
  //   history.push(`/watch?v=${matchesList[0].id}`);
  // };

  handleClickCloseNotification = () => {
    this.setState(
      {
        closeNotification: true
      },
      () => {
        sessionStorage.setItem('isNotifClosed', true);
      }
    );
    const { setNotifStatus } = this.props;
    setNotifStatus(false);
  };

  render() {
    const { matchesList } = this.state;
    return (
      <Fragment>
        {!this.state.closeNotification &&
        !isNotifClosed &&
        matchesList.length > 0 ? (
            <div>
              <Link to={`/watch?v=${matchesList[0].id}`}>
                <div
                  className={s.containerNotification}
                // onClick={this.handleClickLiveWatch}
                >
                  <div className={s.wrapperContainer}>
                    <div className={s.wrapperLeftContainer}>
                      <div className={s.wrapperLeft}>
                        {/* <span > */}
                        <img alt="" src={iconLive} />
                        {/* </span> */}
                        {/* <span className={s.iconArrowRight}>
                      <img alt="#" src={iconArrowRight} />
                      </span> */}
                      </div>
                      <div className={s.wrapperLeft2}>
                        <div className={s.descriptionLive}>
                          {/* <span > */}
                        [LIVE] {matchesList[0].title}
                          {/* </span> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
              <div
                className={s.wrapperClosed}
                onClick={this.handleClickCloseNotification}
              >
                <div>X</div>
              </div>
            </div>
          ) : (
            ''
          )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state
  };
};

const mapDispatchToProps = dispatch => ({
  onHandleVideo: () => dispatch(matchesActions.getMatchesVideo()),
  setNotifStatus: isOpenVar => dispatch(setLiveNotificationVariable(isOpenVar))
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(s)
)(NotificationMobile);
